import React from 'react';

import { Trans } from 'react-i18next';

import { bemCssModules } from '@utils';

import { TCircle } from '../types';
import Caption from './Caption';

import style from './Captions.scss';

const cn = bemCssModules(style, 'Captions');

export type TCaptions = {
  circles: TCircle[];
  onlyCurrencyForMobile?: boolean;
};

const Captions: CustomFC<TCaptions> = ({ circles, onlyCurrencyForMobile, className }) => {
  const isEmpty = !circles.length;

  return (
    <figcaption className={cn(null, [className])}>
      {!isEmpty ? (
        <ul className={cn('list')} aria-hidden="true" role="presentation">
          {circles.map(circle => (
            <Caption
              key={circle.label}
              circle={circle}
              onlyCurrencyForMobile={onlyCurrencyForMobile}
            />
          ))}
        </ul>
      ) : (
        <div className={cn('empty')}>
          <Trans i18nKey="wallet.overview.empty">
            So empty! <br /> Start making transactions and track your balance here
          </Trans>
        </div>
      )}
    </figcaption>
  );
};

export default Captions;
